import { ActionsCell } from "./ActionsCell";

export const columns = [
  {
    Header: 'C. Cliente GN4',
    accessor: 'gn4Customer',
    filterable: true,
    filterMethod: (filter, row) => row.gn4Customer?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'C. Cliente ERP',
    accessor: "erpCustomer",
    filterable: true,
    filterMethod: (filter, row) => row.erpCustomer?.toString()?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'C. Cuenta GN4',
    accessor: "gn4Account",
    filterable: true,
    filterMethod: (filter, row) => row.gn4Account?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'C. Cuenta ERP',
    accessor: "customerAccountSiteNumber",
    filterable: true,
    filterMethod: (filter, row) => row.customerAccountSiteNumber?.toString()?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'N. Cliente',
    accessor: 'name',
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'N. Cuenta',
    accessor: 'account',
    filterable: true,
    filterMethod: (filter, row) => row.account?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Tipo',
    accessor: 'siteUseCode',
    filterable: true,
    filterMethod: (filter, row) => row.siteUseCode?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Acciones',
    filterable: false,
    sortable: false,
    Cell: ActionsCell,
  }
];
